export const CESU_ADD_END_POINT = '/cesu/new';
